import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-nada-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './nada-spinner.component.html',
  styleUrl: './nada-spinner.component.css',
})
export class NadaSpinnerComponent implements OnChanges {
  @Input() size: number = 100;
  @Input() message: string | null = null;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges() {
    this.cdr.detectChanges();
  }
}
